module.exports = __webpack_public_path__ + "static/media/5.3eda9a54.jpg";